import { AUTH } from "./auth";
import { ITEMS } from "./items";
export type { DiscountTypeForQueryParams } from "./items";

export const QUERY_PARAMS = {
	AUTH,
	ITEMS,
};
